import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { PageContent } from '@/components/Layouts'

export const Chats = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'chats'} />

      <PageContent>{t('chats')}</PageContent>
    </>
  )
}
